<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
<template>
    <form-lines-actions :checked_in="checked_in" @add-line="add" @remove-blank-lines="removeBlankLines"/>
    <div class="flex w-full">
        <div class="block text-center w-1/4 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Cód. Artigo
        </div>
        <div class="block text-center w-1/4 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Tamanho
        </div>
        <div class="block text-center w-1/4 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Cor
        </div>
        <div class="block text-center w-1/4 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Qtd
        </div>
        <div class="block text-center w-1/4 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span class="inline sm:hidden">Res.</span>
            <span class="hidden sm:inline">Reservado</span>
        </div>
    </div>
    <div v-for="(line, index) in form.order_line" :key="index"
         class="flex relative flex-wrap w-full justify-around content-center">
        <div class="w-1/5 px-1">
            <input required autocomplete="off" v-model="line.article.code"
                   :disabled="!checked_in.self"
                   class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                   id="article_code" @focusin="recordOldLineArticle(index)" @blur="checkArticleExistence(index)"
                   :ref="el => { if (el) article[index] = el }"
                   type="text"/>
            <p v-if="form.errors['lines.' + index + '.article.code']" class="text-red-500 text-center text-xs italic">
                Este campo é obrigatório</p>
        </div>
        <div class="w-1/5 px-1">
            <input required autocomplete="off" v-model="line.tamanho" @blur="setUniqueSize('tamanho', index, $event)"
                   :disabled="!checked_in.self"
                   class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                   id="tamanho" type="text"/>
            <p v-if="form.errors['lines.' + index + '.tamanho']" class="text-red-500 text-center text-xs italic">Este
                campo é obrigatório</p>
        </div>
        <div class="w-1/5 px-1">
            <input required autocomplete="off" v-model="line.cor" @blur="setUniqueSize('cor', index, $event)"
                   :disabled="!checked_in.self"
                   class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                   id="cor" type="text"/>
            <p v-if="form.errors['lines.' + index + '.cor']" class="text-red-500 text-center text-xs italic">Este campo
                é obrigatório</p>
        </div>
        <div class="w-1/5 px-1">
            <input required autocomplete="off" v-model="line.qtd" @blur="setOne(index, $event)"
                   :disabled="!checked_in.self"
                   class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                   id="qtd" min="1" type="number"/>
            <p v-if="form.errors['lines.' + index + '.qtd']" class="text-red-500 text-center text-xs italic">Este campo
                é obrigatório</p>
        </div>
        <div class="w-1/5 px-1 flex justify-center items-center">
            <label :for="'reserved_'+index" class="block w-full">
                <input v-model="line.reserved"
                       :disabled="!checked_in.self"
                       class="appearance-none mx-auto block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       :id="'reserved_'+index" type="checkbox"/></label>

        </div>
        <button type="button" :disabled="!checked_in.self" @click.prevent="removeLine(index)">
            <i class="cursor-pointer absolute block fa right-0 -mr-4 sm:mr-0 sm:top-2 fa-minus-square mt-4"
               title="Remover Linha"></i>
        </button>
    </div>
</template>

<script>


import Swal from "sweetalert2";
import FormLinesActions from "@/Components/Order/FormLinesActions";
import {onBeforeUpdate, onMounted, ref} from "vue";


export default {
    components: {FormLinesActions},
    props: ['form', 'article_codes', 'checked_in'],
    emits: ['updateFormLines'],
    setup(props, {emit}) {
        const article = ref([]);

        let oldValues = [];

        function recordOldLineArticle(index) {
            oldValues[index] = props.form.order_line[index].article_code;
        }

        function checkArticleExistence(index) {
            if (props.form.order_line[index].article.code !== 'undefined' && props.form.order_line[index].article.code.length > 0) {
                if (props.article_codes[props.form.order_line[index].article.code] === undefined) {
                    props.form.order_line[index].article.code = oldValues[index];
                    props.form.order_line[index].article.price = 0;
                    Swal.fire('Esse artigo não existe!', '', 'info').then(e => article.value[index].focus());
                } else {
                    props.form.order_line[index].article_id = props.form.order_line[index].article.id = props.article_codes[props.form.order_line[index].article.code][0].id;
                    props.form.order_line[index].article.price = props.article_codes[props.form.order_line[index].article.code][0].price;
                }
            } else {
                props.form.order_line[index].article.price = 0;
            }
        }

        function add(emitIt = true) {
            props.form.order_line.push({
                qtd: '',
                article: {
                    'id': '',
                    'code': '',
                    'price': null
                },
                article_id: '',
                tamanho: '',
                cor: '',
                reserved: false
            })

            if (emitIt)
                emit('updateFormLines', props.form.order_line)
        }

        function removeLine(index) {
            if (props.form.order_line.length > 1) {
                props.form.order_line.splice(index, 1)
                emit('updateFormLines', {...props.form.order_line})
            }
        }

        onBeforeUpdate(() => {
            article.value = []
        })

        function removeBlankLines() {
            props.form.order_line = props.form.order_line.filter(function (el) {
                if (el.article.code != '' || el.qtd != '' || el.tamanho != '' || el.cor != '')
                    return el;
            });
            if (props.form.order_line.length === 0)
                add(false);
            emit('updateFormLines', props.form.order_line)
        }

        function setUniqueSize(field, index, event) {
            if(event.target.value === '') {
                props.form.order_line[index][field] = 'U';
            }
        }

        function setOne(index, event) {
            if(event.target.value === '') {
                props.form.order_line[index].qtd = 1;
            }
        }

        return {recordOldLineArticle, checkArticleExistence, removeLine, removeBlankLines, add, article, setUniqueSize, setOne}
    }
}
</script>
